import useSWR from 'swr'
import { RegistrantController } from '@/controllers'
import { config } from '@/config'

export const useSeasonOrganization = () => {
  const {
    data,
    error: uncaughtError,
    isLoading,
    mutate,
  } = useSWR(config.api.endpoints.registrant.seasonOrganization, RegistrantController.currentSeasonOrganization)
  const seasonOrganization = data?.result?.[1] || null
  const season = seasonOrganization?.season || null
  const error = data?.result?.[0] || uncaughtError

  const revalidate = async () => {
    const response = await mutate()

    if (!response) {
      throw new Error('Failed to revalidate seasonOrganization')
    }

    return response.result
  }

  return {
    season,
    seasonOrganization,
    error,
    isLoading,
    revalidate,
  }
}
